import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from './loader-state';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  show(scrollTop?: boolean) {
    this.loaderSubject.next(<LoaderState>{ show: true });
    scrollTop && this.scrollToTop()
  }

  hide(scrollTop?: boolean) {
    this.loaderSubject.next(<LoaderState>{ show: false });
    scrollTop && this.scrollToTop()
  }

  scrollToTop() {
    document.getElementById('loader-scroll').scrollIntoView()
  }
}
